module.exports = __webpack_public_path__ + "img/message_white.e30f9a7b.svg";